let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iA8EQ")).then(() => parcelRequire('i33Fc'));